
$(document).ready(function() {
  $('#gorgias-chat-container').click(function () {
    alert('clicked');
  });
  $('#search-icon').click(function () {
    $(this).find('form').addClass('expanded');
    $('#q_header').focus();
  });
  $("#q_header").focus(function(){
       $(this).parent().addClass('expanded');

  }).blur(function(){
       $(this).parent().removeClass('expanded');
  })
  if ($('.flex-active-slide').hasClass('invert-header')) {
  	$('[data-section-id="header"]').addClass('invert-header');
  }
  $("#q_header").focus(function(){
       $(this).parent().addClass('expanded');

  }).blur(function(){
       $(this).parent().removeClass('expanded');
  })
});

$('.js-slideshow-section').on({
  afterChange: function(event, slick, currentSlide, nextSlide) {
     if ($('.slick-active').hasClass('invert-header')) {
         $('[data-section-id="header"]').addClass('invert-header');
         $('.full-width-slideshow').addClass('invert-header');
     } else {
         $('[data-section-id="header"]').removeClass('invert-header');
         $('.full-width-slideshow').removeClass('invert-header');
     }
  }
});

$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

     //>=, not <=
    if (scroll >= 32) {
        $('[data-section-id="header"]').addClass('scrolled');
      	$('.index-sections').addClass('scrolled');
      	$('#content').addClass('scrolled');
    } else {
        $('[data-section-id="header"]').removeClass('scrolled');
      	$('.index-sections').removeClass('scrolled');
        $('#content').removeClass('scrolled');
    }
}); 




$(document).ready(function() {

  $('.show-sort').on('click',function(){
        $('#sortme-custom').toggleClass('open');
    	if($('#collection-sidebar').hasClass('open')){
           $('#collection-sidebar').removeClass('open')
        }
  });
  $("#sort-by option").each(function() {
    //get values of all option
    var val = $(this).val();
    var valText = $(this).text();

    //do magic create boxes like checkbox
    $("#sortme-custom").append('<div class="selectbox" data-sort-by="' + val + '"><span>' + valText + '</span></div>');

  });
  //remove empty selectbox
  $('.selectbox[data-color=""]').remove();

  //change select box on click
  $(".selectbox").click(function() {
    //remove selected from others
    $(".selectbox").removeClass("active");
    //do active to selected
    $(this).addClass("active");
    //get value
    var optVal = $(this).data("sort-by");

    $("#sort-by").val(optVal).change() 

  });
  
  $('.toggle').click(function(e) {
      e.preventDefault();

      var $this = $(this);

      if ($this.hasClass('shown')) {
          $this.removeClass('shown');
      } else {
          $this.parent().parent().find('a').removeClass('shown');
          $this.toggleClass('shown');
      }

      if ($this.next().hasClass('shown')) {
          $this.next().removeClass('shown');
          $this.next().slideUp(350);
      } else {
          $this.parent().parent().find('li .inner').removeClass('shown');
          $this.parent().parent().find('li .inner').slideUp(350);
          $this.next().toggleClass('shown');
          $this.next().slideToggle(350);
      }
  });
  
  var conceptName = $('#sort-by').find(":selected").val();
	$('.selectbox[data-sort-by="'+ conceptName +'"]').addClass('active');
});  

$(document).ready(function() {
  $('.product-main-image.product-video video').trigger('play');
});

$(document).ready(function() {
  var $videoDesktop = $("[data-section-type='full-width-video'] .video-desktop video");
  var $videoMobile = $("[data-section-type='full-width-video'] .video-mobile video");
  function videoHandler(){
      $videoDesktop[0][ $(window).width()<940 ? "pause" : "play" ]();
      $videoMobile[0][ $(window).width()>939 ? "pause" : "play" ]();
  }
  if($("[data-section-type='full-width-video'] .video-desktop video").length >0 ){
     $(window).on("resize load", videoHandler); 
  }
  if ($("[data-section-type='full-width-video']").hasClass('invert-header')) {
     $('[data-section-id="header"]').addClass('invert-header');
  }

  $("#sound-on").click(function() {
      if ($("[data-section-type='full-width-video'] .video-desktop video").prop('muted')) {
          $("[data-section-type='full-width-video'] .video-desktop video").prop('muted', false);
          $('#sound-on').text("SOUND OFF");
      } else {
          $("[data-section-type='full-width-video'] .video-desktop video").prop('muted', true);
          $('#sound-on').text("SOUND ON");
      }
  });
  $("#sound-on-mobile").click(function() {
      if ($("[data-section-type='full-width-video'] .video-mobile video").prop('muted')) {
          $("[data-section-type='full-width-video'] .video-mobile video").prop('muted', false);
          $('#sound-on-mobile').text("SOUND OFF");
      } else {
          $("[data-section-type='full-width-video'] .video-mobile video").prop('muted', true);
          $('#sound-on-mobile').text("SOUND ON");
      }
  });
  setTimeout(function() { 
    GorgiasChat.init().then(function() {
      GorgiasChat.on('widget:closed', function(data) {
        $('#gorgias-chat-container iframe#chat-button').removeClass('visible');
      });
    })
    var isWindowStyleAppended = false
      setTimeout(() => {
        var container = document.querySelector('#gorgias-chat-container');
        var chatWindowHead = container?.querySelector('#chat-window')?.contentWindow.document.querySelector('head');

        if (chatWindowHead?.children.length && !isWindowStyleAppended) {
          var windowStyle = document.createElement('style');
          windowStyle.textContent = '#self-service-portal-container button.primary {background-color: #4a8df9 !important;}'; // the custom CSS for the chat button
          chatWindowHead.appendChild(windowStyle);     
          isWindowStyleAppended = true;
        }

      }, 800);
  }, 3000);
        

	$(".cart-qty").change(function() {
        $('#update-cart').click();
    });
}); 

        function ToggleGorgias() {
        	$('#gorgias-chat-container iframe#chat-button').addClass('visible');
        }